// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.make-rojo {
    background-color: #d01d17;
}

.make-letra-rojo {
    color: #d01d17;
}

.make-boton-rojo {
    color: #d01d17;
    border-color: #d01d17;
}

.make-borde-rojo {
    border-color: #d01d17;
}

.make-boton-rojo-relleno {
    color: #e9e3e3;
    border-color: #d01d17;
    background-color: #d01d17;
}

.make-cafeobscuro {
    background-color: #391410;
}

.make-letra-cafeobscuro {
    color: #391410;
}

.make-boton-cafeobscuro {
    color: #391410;
    border-color: #391410;
}

.make-boton-cafeobscuro-relleno {
    color: #e9e3e3;
    border-color: #391410;
    background-color: #391410;
}

.make-borde-cafeoscuro {
    border-color: #391410;
}

.make-rosado {
    background-color: #e32729;
}

.make-letra-rosado {
    color: #e32729;
}

.make-boton-rosado {
    color: #e32729;
    border-color: #e32729;
}

.make-boton-rosado-relleno {
    color: #e9e3e3;
    border-color: #e32729;
    background-color: #e32729;
}

.make-gris {
    background-color: #445576;
}

.make-letra-gris {
    color: #445576;
}

.make-boton-gris {
    color: #445576;
    border-color: #445576;
}

.make-boton-gris-relleno {
    color: #e9e3e3;
    border-color: #445576;
    background-color: #445576;
}

.make-amarillo {
    background-color: #e97a0d;
}

.make-letra-amarillo {
    color: #e97a0d;
}

.make-boton-amarillo {
    color: #e97a0d;
    border-color: #e97a0d;
}

.make-boton-amarillo-relleno {
    color: #e9e3e3;
    border-color: #e97a0d;
    background-color: #e97a0d;
}

.make-cafeclaro {
    background-color: #8c1819;
}

.make-letra-cafeclaro {
    color: #8c1819;
}

.make-boton-cafeclaro {
    color: #8c1819;
    border-color: #8c1819;
}

.make-boton-cafeclaro-relleno {
    color: #e9e3e3;
    border-color: #8c1819;
    background-color: #8c1819;
}

* {
    font-family: 'Nunito Sans' !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ingrediente-pan-presentacion-dialog/ingrediente-pan-presentacion-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".make-rojo {\r\n    background-color: #d01d17;\r\n}\r\n\r\n.make-letra-rojo {\r\n    color: #d01d17;\r\n}\r\n\r\n.make-boton-rojo {\r\n    color: #d01d17;\r\n    border-color: #d01d17;\r\n}\r\n\r\n.make-borde-rojo {\r\n    border-color: #d01d17;\r\n}\r\n\r\n.make-boton-rojo-relleno {\r\n    color: #e9e3e3;\r\n    border-color: #d01d17;\r\n    background-color: #d01d17;\r\n}\r\n\r\n.make-cafeobscuro {\r\n    background-color: #391410;\r\n}\r\n\r\n.make-letra-cafeobscuro {\r\n    color: #391410;\r\n}\r\n\r\n.make-boton-cafeobscuro {\r\n    color: #391410;\r\n    border-color: #391410;\r\n}\r\n\r\n.make-boton-cafeobscuro-relleno {\r\n    color: #e9e3e3;\r\n    border-color: #391410;\r\n    background-color: #391410;\r\n}\r\n\r\n.make-borde-cafeoscuro {\r\n    border-color: #391410;\r\n}\r\n\r\n.make-rosado {\r\n    background-color: #e32729;\r\n}\r\n\r\n.make-letra-rosado {\r\n    color: #e32729;\r\n}\r\n\r\n.make-boton-rosado {\r\n    color: #e32729;\r\n    border-color: #e32729;\r\n}\r\n\r\n.make-boton-rosado-relleno {\r\n    color: #e9e3e3;\r\n    border-color: #e32729;\r\n    background-color: #e32729;\r\n}\r\n\r\n.make-gris {\r\n    background-color: #445576;\r\n}\r\n\r\n.make-letra-gris {\r\n    color: #445576;\r\n}\r\n\r\n.make-boton-gris {\r\n    color: #445576;\r\n    border-color: #445576;\r\n}\r\n\r\n.make-boton-gris-relleno {\r\n    color: #e9e3e3;\r\n    border-color: #445576;\r\n    background-color: #445576;\r\n}\r\n\r\n.make-amarillo {\r\n    background-color: #e97a0d;\r\n}\r\n\r\n.make-letra-amarillo {\r\n    color: #e97a0d;\r\n}\r\n\r\n.make-boton-amarillo {\r\n    color: #e97a0d;\r\n    border-color: #e97a0d;\r\n}\r\n\r\n.make-boton-amarillo-relleno {\r\n    color: #e9e3e3;\r\n    border-color: #e97a0d;\r\n    background-color: #e97a0d;\r\n}\r\n\r\n.make-cafeclaro {\r\n    background-color: #8c1819;\r\n}\r\n\r\n.make-letra-cafeclaro {\r\n    color: #8c1819;\r\n}\r\n\r\n.make-boton-cafeclaro {\r\n    color: #8c1819;\r\n    border-color: #8c1819;\r\n}\r\n\r\n.make-boton-cafeclaro-relleno {\r\n    color: #e9e3e3;\r\n    border-color: #8c1819;\r\n    background-color: #8c1819;\r\n}\r\n\r\n* {\r\n    font-family: 'Nunito Sans' !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
